import { render, staticRenderFns } from "./DxFieldsetHeader.vue?vue&type=template&id=1b32b26a&scoped=true&"
import script from "./DxFieldsetHeader.vue?vue&type=script&lang=js&"
export * from "./DxFieldsetHeader.vue?vue&type=script&lang=js&"
import style0 from "./DxFieldsetHeader.vue?vue&type=style&index=0&id=1b32b26a&lang=scss&scoped=true&"
import style1 from "./DxFieldsetHeader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b32b26a",
  null
  
)

export default component.exports